import type {
  EndGameSessionRequest,
  EndGameSessionResponse,
  GameSession,
  StartGameSessionRequest,
} from '@goodtime/shared';
import { api } from './client';

/** {@code POST /v1/sessions} — start a session in the given room.
 * Server stamps {@code started}; {@code ended} stays null until the
 * session is closed via {@link endSession}. */
export function startSession(req: StartGameSessionRequest): Promise<GameSession> {
  return api<GameSession>('/sessions', {
    method: 'POST',
    body: JSON.stringify(req),
  });
}

/** {@code GET /v1/sessions/{id}} — fetch a session by id. */
export function fetchSession(id: string): Promise<GameSession> {
  return api<GameSession>(`/sessions/${encodeURIComponent(id)}`);
}

/** {@code POST /v1/sessions/{id}/end} — finalise a session: persists
 * the score, awards coins to the wallet, marks ended. Composite
 * response so the client can render the final state without a
 * follow-up fetch. */
export function endSession(id: string, req: EndGameSessionRequest): Promise<EndGameSessionResponse> {
  return api<EndGameSessionResponse>(`/sessions/${encodeURIComponent(id)}/end`, {
    method: 'POST',
    body: JSON.stringify(req),
  });
}
